export default "__VITE_ASSET__CQtB5dLw__"